<!--<ng-container *ngIf="isProd; else nonProductionEnv">-->
<!--    <span class="app-name sonect-flamingo-color font-weight-500">Backoffice</span>-->
<!--</ng-container>-->
<!--<ng-template #nonProductionEnv>-->
<!--    <img [src]="logoImagePath" width="140px">-->
<!--</ng-template>-->
<ng-container>
    <span class="app-name sonect-flamingo-color font-weight-500">Backoffice</span>
</ng-container>
